import { Divider, Grid } from '@mui/material';
import ProductInfoItem from '../ProductInfoItem/ProductInfoItem';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { UpdateProductInfoFormValues } from 'pages/product/CreateProductPage/updateProductInfoValidationSchema';
import { currencies } from 'common/constants';

export default function ProductInformationFormDetails() {
  const { getValues } = useFormContext<UpdateProductInfoFormValues>();
  const values = getValues();

  const fields = [
    {
      label: 'English Name',
      value: values.translations.en.name,
      show: !!values.translations?.en?.name,
    },
    {
      label: 'Arabic Name',
      value: values.translations.ar.name,
      show: !!values.translations?.ar?.name,
    },
    {
      label: 'Weight',
      value: `${values.weight}${values.weightUnit}`,
      show: !!values.weight,
    },
    {
      label: 'Estimated Weight',
      value: `${values.estimatedWeight}${values.weightUnit}`,
      show: !!values.estimatedWeight,
    },
    {
      label: 'Drained Weight',
      value: `${values.drainedWeight}${values.weightUnit}`,
      show: !!values.drainedWeight,
    },
    {
      label: 'Country of Manufacture',
      value: `${values.countryOfManufactureISO}`,
      show: !!values.countryOfManufactureISO,
    },
    {
      label: 'Country of Registration',
      value: `${values.countryOfRegistrationISO}`,
      show: !!values.countryOfRegistrationISO,
    },
    {
      label: 'Barcode',
      value: `${values.barcode}`,
      show: !!values.barcode,
    },
    {
      label: 'Price',
      value: `${currencies.shekel}${Number(values?.price)?.toFixed(2)}`,
      show: !!values?.price,
    },
  ].filter((field) => field.show);

  return (
    <>
      {fields.map((field, index) => (
        <React.Fragment key={field.label}>
          <Grid size={{ xs: 12, md: 6 }}>
            <ProductInfoItem label={field.label} value={field.value} />
          </Grid>

          {index % 2 === 1 && index < fields.length - 1 && (
            <Grid size={12}>
              <Divider />
            </Grid>
          )}
        </React.Fragment>
      ))}
    </>
  );
}